import { oz } from '@weft/utils';
import { MeasuredPriceSchema } from './measured-price-schema';

export const MeasuredPriceBreakdownSchema = oz.object({
  tierIndex: oz.number(),
  measuredPrice: MeasuredPriceSchema,
}).array();

export type MeasuredPriceBreakdown = oz.infer<typeof MeasuredPriceBreakdownSchema>;